import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import BankCard from '../../BankCard/BankCard';
import BottomActionButton from '../../shared/BottomActionButton/BottomActionButton';
import './Onboarding.css';

function Onboarding() {
  const navigate = useNavigate();
  const { onboarding } = useContext(TranslationContext);

  return (
    <section className="onboarding">
      <div className="onboarding__content">
        <div className="onboarding__cards">
          <BankCard
            cardStyle="aurora"
            size="onboardingBack"
            className="onboarding__card onboarding__card--aurora"
            aria-hidden="true"
          />
          <BankCard
            cardStyle="sunset"
            size="onboardingFront"
            lastFour="8866"
            className="onboarding__card onboarding__card--sunset"
          />
        </div>

        <div className="onboarding__copy">
          <h1 className="onboarding__title">
            {onboarding.heroTitleLine1}
            <br />
            {onboarding.heroTitleLine2}
          </h1>
          <p className="onboarding__subtitle">
            {onboarding.heroSubtitle}
          </p>
        </div>
      </div>

      <BottomActionButton
        className="onboarding__cta"
        onClick={() => navigate('/onboarding/terms')}
      >
        {onboarding.getStarted}
      </BottomActionButton>
    </section>
  );
}

export default Onboarding;
